import {
  ApeironBlueButton,
  INFO_POPUP_TYPE,
  InfoPopup,
  useAccountContext,
  useDate
} from '@apeiron/temp'
import { Box, styled, Typography } from '@mui/material'
import { ROUTE } from '@src/constants/route'
import { useBattlepassContext } from '@src/contexts/battle/demo/BattlepassContext'
import { useRouter } from 'next/router'
import { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const Popup = styled(InfoPopup)`
  max-width: 500px;
  width: 90%;

  .Custom-Content {
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;
    ${props => props.theme.breakpoints.up('res480')} {
      gap: 20px;
      padding: 0px 20px 30px 20px;
    }
    ${props => props.theme.breakpoints.down('res480')} {
      gap: 14px;
      padding: 0px 20px 30px 20px;
    }
  }
`

const Title = styled(Typography)`
  color: #f3eeca;
  font-weight: 300;
  ${props => props.theme.breakpoints.up('res480')} {
    font-size: 24px;
    line-height: 24px;
  }
  ${props => props.theme.breakpoints.down('res480')} {
    font-size: 20px;
    line-height: 20px;
  }
`

const ItemsContainer = styled(Box)`
  display: flex;
  gap: 10px;
  width: 100%;
`

const ItemContainer = styled(Box)`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 12px;
`

const ItemTitle = styled(Typography)`
  color: #f3eeca;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
`

const BootyValue = styled(Typography)`
  background-color: #8cff3211;
  border-radius: 8px;
  border: 2px solid #67ff4f;
  color: #67ff4f;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 26px;
  padding: 10px 0px;
  text-align: center;
  width: 160px;
`

const StartButton = styled(ApeironBlueButton)`
  background-color: #2256d4;
  border-radius: 4px;
  font-size: 18px;
  font-weight: 500;
  height: unset;
  padding: 10px 30px;
  margin-top: 10px;
`

const BurnSuccessPopup: FC<Props> = () => {
  const { t } = useTranslation()

  const { account } = useAccountContext()

  const { burnSuccess, setBurnSuccess } = useBattlepassContext()

  const { textTimeWithSeparator } = useDate()

  const router = useRouter()

  const bootyRemain = account.game?.battlePass.booty.remainTime || 0

  const handleOnClose = useCallback(() => {
    setBurnSuccess(false)
  }, [setBurnSuccess])

  const handleOnStartGame = useCallback(() => {
    handleOnClose()
    router.push(ROUTE.BATTLE_DEMO_GAME)
  }, [handleOnClose, router])

  return (
    <Popup
      open={burnSuccess}
      type={INFO_POPUP_TYPE.PURPLE}
      onClose={handleOnClose}
    >
      <Title>{t('battle_demo.you_now_have')}</Title>
      <ItemsContainer>
        <ItemContainer>
          <ItemTitle>{t('battle_demo.booty_left')}</ItemTitle>
          <BootyValue>
            {textTimeWithSeparator({ duration: bootyRemain * 1000 }, ':', ':')}
          </BootyValue>
        </ItemContainer>
      </ItemsContainer>
      <StartButton onClick={handleOnStartGame}>
        {t('battle_demo.pass.popup.button.start')}
      </StartButton>
    </Popup>
  )
}

type Props = {}

export default BurnSuccessPopup
